import React, { useMemo, useRef, useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as PR from "../prime-modules/index";
import { getUserEmail } from "../services/api";
import { editorConfig } from "./reuse";

const SendEmail = ({ visible, onClose, userId }) => {
  const fromEmail = process.env?.REACT_APP_SUPPORT_EMAIL;
  const dispatch = useDispatch();
  const toast = useRef();
  const adminData = useSelector((state) => state.adminAuth.adminSessionData);
  const [loading, setLoading] = useState(false)
  const headers = useMemo(() => {
    return { sessionid: adminData.sessionId };
  }, [adminData.sessionId]);
  const [bcc, setBcc] = useState([]);
  const [subject, setSubject] = useState("");
  const [editorText, setEditorText] = useState("");
  const [errors, setErrors] = useState({
    subject: "",
    content: "",
  });
  const bccPlaceholderValue = bcc?.length === 0 ? "test@example.com" : "";

  const modules = editorConfig.modules;

  const handleSendEmail = useCallback(
    (e) => {
      setLoading(true)
      e.preventDefault();
      const newErrors = {
        subject: (subject || "").trim() === "" ? "Subject is required" : "",
        content: !isContentValid(editorText) ? "Content is required" : "",
      };
      setErrors(newErrors);
      if (newErrors.subject || newErrors.content){
        return setLoading(false);
      } 
      const reqObj = {
        bcc: bcc.map(email => email?.replace(/\s+/g, '')),
        subject: subject,
        content: editorText,
      };
      const detailsResponse = (response) => {
        if (response.result === "SUCCESS") {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: "Your email has been sent successfully.",
          });
          setBcc([]);
          setSubject("");
          setEditorText("");
          onClose();
          setLoading(false);
        } else {
          const error = response.error;
          toast.current.show({
            severity: error.severity,
            summary: "Error",
            detail: error.errorMsg ? error.errorMsg : error.summary,
          });
          setLoading(false);
        }
      };

     getUserEmail(reqObj, userId?.userId, headers, dispatch, detailsResponse);
    
    },
    [dispatch, headers, bcc, editorText, subject, userId, onClose]
  );

  const isContentValid = (html) => {
    const plainText = (html || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();
    return plainText !== "";
  };  

  const onHideEmailHandler = () => {
    onClose();
    setBcc([]);
    setSubject("");
    setEditorText("");
    setErrors({});
  };

  useEffect(() => {
    if ((subject || "").trim() !== "") {
      setErrors((prev) => ({ ...prev, subject: "" }));
    }
  }, [subject]);

  useEffect(() => {
    if (isContentValid(editorText)) {
      setErrors((prev) => ({ ...prev, content: "" }));
    }
  }, [editorText]);
  

  return (
    <>
        <PR.Dialog
        header="Send Email"
        visible={visible}
        onHide={onHideEmailHandler}
        draggable={false}
        blockScroll={true}
        className="filter-dialog order-filters-dialog send-email-dialog"
        >
        <form autoComplete="off" className="mt-0" onSubmit={handleSendEmail}>
            <div className="grid">
            <div className="col-12 md:col-12">
                <div className="flex flex-column1 align-items-center gap-2">
                <label htmlFor="tomail" className="title-label">
                    To
                </label>
                <PR.InputText
                    placeholder="test@example.com"
                    name="tomail"
                    value={userId?.to}
                    inputId="tomail"
                    autoComplete="off"
                    className="email-input"
                    readOnly
                />
                </div>
            </div>
            <div className="col-12 md:col-12">
                <div className="flex flex-column1 align-items-center gap-2">
                <label htmlFor="tomail" className="title-label">
                    From
                </label>
                <PR.InputText
                    placeholder="test@example.com"
                    name="frommail"
                    value={fromEmail}
                    inputId="frommail"
                    autoComplete="off"
                    className="email-input"
                    readOnly
                />
                </div>
            </div>
            <div className="col-12 md:col-12">
                <div className="flex flex-column1 align-items-center gap-2">
                <label htmlFor="tomail" className="title-label">
                    BCC
                </label>
                <PR.Chips
                    placeholder={bccPlaceholderValue}
                    name="bcc"
                    value={bcc.map(email => email?.replace(/\s+/g, ""))}
                    onChange={(e) => setBcc(e.value)}
                    addOnBlur={true}
                    allowDuplicate={false}
                    separator=","
                    inputId="bcc"
                    autoComplete="off"
                    className="email-input"
                />
                </div>
            </div>
            </div>
            <div className="grid mt-1">
            <div className="col-12 md:col-12">
                <div className="flex flex-column align-items-center gap-2">
                <PR.InputText
                    placeholder="Subject"
                    name="subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    inputId="subject"
                    autoComplete="off"
                    className="email-input subject-input"
                />
                </div>
                {errors.subject && (
                <small className="p-error">{errors.subject}</small>
                )}
            </div>
            <div className="col-12 md:col-12">
                <PR.Editor
                value={editorText}
                onTextChange={(e) => setEditorText(e.htmlValue)}
                className="send-email-editor"
                placeholder="Email content"
                modules={modules}
                />
                {errors.content && (
                <small className="p-error">{errors.content}</small>
                )}
            </div>
            </div>
            <div className="buttons-sections flex align-items-center justify-content-end gap-3">
            <PR.Button
                label="Cancel"
                type="button"
                className="confirm-button reset-btn min-width"
                onClick={onHideEmailHandler}
            />
            <PR.Button
                label="Send Email"
                disabled={loading}
                type="submit"
                className="confirm-button min-width send"
            />
            </div>
        </form>
        </PR.Dialog>
        <PR.Toast ref={toast} position='top-right' />
    </>
  );
};

export default SendEmail;
